module.exports = __webpack_public_path__ + "static/media/cards.54f6face.png";